function trackAboutBonusPointClicks() {
    $(".pop-about-link").click(function () {
        var gaEventName = $(this).data('bonus-points-url');
        if(gaEventName !== null) {
            OTDataLayer.push({'event': gaEventName});
        }
    });
};

$(function () {
    trackAboutBonusPointClicks();
});
